function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.156 0a10.156 10.156 0 1010.156 10.156A10.168 10.168 0 0010.156 0zm0 18.75a8.594 8.594 0 118.594-8.594 8.604 8.604 0 01-8.594 8.594zm4.096-9.243l-3.515 3.906a.781.781 0 01-1.161 0L6.06 9.507a.781.781 0 011.161-1.045l2.935 3.26 2.935-3.26a.781.781 0 111.162 1.045z",
  fill: "#B4C0CF"
});

var SvgBespokenIconCollapsed = function SvgBespokenIconCollapsed(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 21 21",
    fill: "none"
  }, props), _ref);
};

export default SvgBespokenIconCollapsed;